import { FAQS } from "../data/content";
import { Reveal } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export const FAQ = () => {
  return (
    <section data-testid="faq-section" className="py-10 sm:py-14 lg:py-18 bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="text-center">
          <Reveal>
            <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-brand-teal">
              Frequently Asked
            </p>
          </Reveal>
          <Reveal delay={1}>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-charcoal leading-[1.05]">
              Catering Questions, Answered.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={2}>
          <Accordion
            type="single"
            collapsible
            className="mt-10 divide-y divide-black/10 border-t border-b border-black/10"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="py-5 text-left text-[15px] sm:text-[17px] font-display font-bold text-brand-charcoal hover:no-underline hover:text-brand-teal data-[state=open]:text-brand-teal"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[14.5px] text-brand-charcoal/75 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
